var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.63235H15M7.5 12.5735V7.80882M10.5 12.5735V7.80882M12 15.75H6C5.17157 15.75 4.5 15.0389 4.5 14.1618V5.42647C4.5 4.98789 4.83579 4.63235 5.25 4.63235H12.75C13.1642 4.63235 13.5 4.98789 13.5 5.42647V14.1618C13.5 15.0389 12.8284 15.75 12 15.75ZM7.5 4.63235H10.5C10.9142 4.63235 11.25 4.27681 11.25 3.83824V3.04412C11.25 2.60554 10.9142 2.25 10.5 2.25H7.5C7.08579 2.25 6.75 2.60554 6.75 3.04412V3.83824C6.75 4.27681 7.08579 4.63235 7.5 4.63235Z",
    stroke: "#F31825",
    strokeWidth: 1.53,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountStop);
export default __webpack_public_path__ + "static/media/AccountStop.df29e0096b9b03b4b27dbcae2e9640d1.svg";
export { ForwardRef as ReactComponent };